import "./SetUpInfo.scss";
import checkIcon from "assets/icons/check.svg";
import setPasswordIcon from "assets/images/setPassword.svg";

const SetUpInfo = () => {
  return (
    <div className="setup-info-container">
      <div className="setup-info-title">
        Welcome to Your
        <br /> OTC Account
      </div>
      <div className="setup-info-desc">
        <span>Set your password</span> to complete registration.
      </div>
      <div className="access-info-container">
        <div className="access-title">What you’ll get access to:</div>
        <div className="access-reason">
          <img src={checkIcon} alt="check" className="check-icon" />
          <span className="access-desc">
            Crypto-to-fiat transactions with fixed rates
          </span>
        </div>
        <div className="access-reason">
          <img src={checkIcon} alt="check" className="check-icon" />
          <span className="access-desc">Full trade history in one place</span>
        </div>
        <div className="access-reason">
          <img src={checkIcon} alt="check" className="check-icon" />
          <span className="access-desc">
            Priority support from our OTC team
          </span>
        </div>
      </div>
      <div className="kyc-info-container">
        <img
          src={setPasswordIcon}
          alt="set-password"
          className="set-password-icon"
        />
        <div className="kyc-text">
          <span>KYC approval takes 5–10 minutes.</span>
          <br />
          You’ll be notified once it’s done — and can start your first
          transaction right away.
        </div>
      </div>
    </div>
  );
};

export default SetUpInfo;
